import { PortalMenuSettingsDto } from './dto/portal-menu-settings.dto';
import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/shared';
import { OnlinePaymentSettingsDto } from './dto/online-payment-settings.dto';
import { EmailNotificationSettingsDto } from './dto/email-notification-settings.dto';
import { MiscSettingsDto } from './dto/misc-settings.dto';
import { EmailProviderSettingsDto } from './dto/email-provider-settings.dto';
import { DefaultContentSettingsDto } from './dto/default-content-settings.dto';

@Injectable({
  providedIn: 'root',
})
export class GlobalSettingsService {
  constructor(private _apiService: ApiService) {}

  getOnlinePaymentSettings(): Promise<OnlinePaymentSettingsDto> {
    return this._apiService.get('GlobalSettings/PaymentSettings');
  }

  updateOnlinePaymentSettings(paymentSettings: OnlinePaymentSettingsDto): Promise<void> {
    return this._apiService.post('GlobalSettings/PaymentSettings', paymentSettings);
  }

  getEmailNotificationSettings(): Promise<EmailNotificationSettingsDto> {
    return this._apiService.get('GlobalSettings/EmailNotificationSettings');
  }

  updateEmailNotificationSettings(emailNotificationSettings: EmailNotificationSettingsDto): Promise<EmailNotificationSettingsDto> {
    return this._apiService.post('GlobalSettings/EmailNotificationSettings', emailNotificationSettings);
  }

  getMiscSettings(): Promise<MiscSettingsDto> {
    return this._apiService.get('GlobalSettings/MiscSettings');
  }

  updateMiscSettings(miscSettings: MiscSettingsDto): Promise<MiscSettingsDto> {
    return this._apiService.post('GlobalSettings/MiscSettings', miscSettings);
  }
  getEmailProviderSettings(): Promise<EmailProviderSettingsDto> {
    return this._apiService.get('GlobalSettings/EmailProviders');
  }
  updateEmailProviderSettings(settings: EmailProviderSettingsDto) {
    return this._apiService.post('GlobalSettings/EmailProviders', settings);
  }
  getDefaultContentSettings() {
    return this._apiService.get('GlobalSettings/DefaultContent');
  }
  updateDefaultContentSettings(defaultContentSettings: DefaultContentSettingsDto) {
    return this._apiService.post('GlobalSettings/DefaultContent', defaultContentSettings);
  }

  getPortalMenuSettings(settingBatch?: string) {
    return this._apiService.get('GlobalSettings/PortalMenuSettings');
  }

  upsertPortalMenuSettings(dto: PortalMenuSettingsDto) {
    return this._apiService.post('GlobalSettings/PortalMenuSettings', dto);
  }
}
